module.exports = {
  // 页面title
  title: 'Vanisper',
  // 发布pages的仓库名（博客部署文件存放的仓库名）
  pagesRepo: 'blog',
  // 网站配置信息
  siteOptions: {
    title: 'Vanisper',
    subtitle: '星星会说话，石头会开花',
    author: 'Vangogh',
    description: '前端全栈开发者',
    github: 'https://github.com/Vanisper/gitee-blog',
    navMenu: {
      'http://localhost:8080': '首页', //外链
      '/article': '文章',
      'https://coolshell.cn': '友情链接',
      // '/works': '作品',
      '/article/关于本站': '关于本站',
    },
    skills: [
      'Vue',
      'React',
      'JavaScript',
      'Css',
      'Java',
      'C#',
      'MySql',
      'Sql Server',
      'MongoDB',
    ],
  },
  // 评论配置信息
  commentOptions: {
    owner: 'Vanisper',
    repo: 'blog',
    clientId: '13f12c4d3203ceee7d22',
    clientSecret: '4de1abe7fa4d21bc1c76b6e03a86f0cc2d4afc83',
  },
  // gitee oauth
  giteeOauthOptions: {
    baseOauthUrl: 'https://gitee.com/oauth',
    clientId:
      '1353aecd20aa1d4dda4f6a4fb99d0f7504004dd57971edd64bbccc20568fd492',
    clientSecret:
      '43a9e91a26c7e506bae2a6d3d894a065490c8d355bc7b659efda05843a39614e',
    redirectUri: 'https://Vanisper.gitee.io/redirect',
  },
  // gitee api
  giteeApiOptions: {
    baseApiURL: 'https://gitee.com/api/v5',
    owner: 'Vanisper',
    repo: 'gitee-blog-db',
  },
}
